import React from "react";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import { NodeSelect, NodeTextField } from "../../../../NodeUI";
import ToggleRow from "../../../../common/ToggleRow";
import AgentConfigSection from "../../AgentConfigSection";
import { MISSION_AGENT_TEMPLATES } from "./missionTemplateDefaults";
import "./MissionHarness.css";

/**
 * Host config: when enabled, every new session for this agent auto-attaches a mission harness
 * using the selected template and the policy below (persisted as defaultMissionPolicyOverride).
 */
export default function MissionHarnessSection({
  harnessEnabled,
  setHarnessEnabled,
  defaultMissionTemplateId,
  setDefaultMissionTemplateId,
  defaultObjectiveTemplate,
  setDefaultObjectiveTemplate,
  tenantTemplates = [],
}) {
  const templateId = defaultMissionTemplateId || "standard_agent";
  const policyDisabled = !harnessEnabled;
  const templateOptions = [
    ...MISSION_AGENT_TEMPLATES.map((t) => ({ ...t, icon: ScheduleOutlinedIcon })),
    ...tenantTemplates.map((t) => ({
      value: t.id,
      label: t.name,
      description: t.description,
      icon: ScheduleOutlinedIcon,
    })),
  ];

  return (
    <AgentConfigSection id="missionHarness">
      <ToggleRow
        checked={harnessEnabled === true}
        onChange={setHarnessEnabled}
        title="Run every new session as a mission"
        description="New sessions for this agent automatically become long-running missions with a heartbeat and platform safety caps."
      />

      <div
        className={
          policyDisabled
            ? "mission-harness__fields-disabled mission-harness__policy-stack"
            : "mission-harness__policy-stack"
        }
        aria-disabled={policyDisabled}
      >
        <NodeSelect
          label="Mission template"
          descriptive
          disabled={policyDisabled}
          value={templateId}
          onChange={setDefaultMissionTemplateId}
          options={templateOptions}
        />

        <NodeTextField
          label="Default objective"
          disabled={policyDisabled}
          value={defaultObjectiveTemplate || ""}
          onChange={setDefaultObjectiveTemplate}
          multiline
          minRows={3}
          placeholder="What should each mission for this agent accomplish?"
          helperText="Applied to every new session when auto-attach is on. Individual chats can override this later."
        />
      </div>
    </AgentConfigSection>
  );
}
